/**
 * Posthog events constants
 */
export enum PosthogEvent {
  // Schedule request (Vacay)
  USER_SUBMITTED_SCHEDULE_REQUEST_ON_OPEN_OR_PLANNING_SCHEDULE = 'user_submitted_schedule_request_on_open_or_planning_schedule',
  USER_SUBMITTED_SCHEDULE_REQUEST_ON_DRAFT_OR_PUBLISHED_SCHEDULE = 'user_submitted_schedule_request_on_draft_or_published_schedule',
  VACAY_USER_SUBMITTED_SCHEDULE_REQUEST = 'vacay_user_submitted_schedule_request',
  VACAY_USER_SUBMITTED_WISH = 'vacay_user_submitted_wish',

  // ROSTr
  ROSTR_USER_CHANGED_SETTINGS = 'rostr_user_changed_settings',
  ROSTR_USER_CHANGED_MAIN_STATISTICS = 'rostr_user_changed_main_statistics',
  ROSTR_USER_CHANGED_WEEKLY_STATISTICS = 'rostr_user_changed_weekly_statistics',
  ROSTR_USER_CLICKED_UNSELECT_ALL = 'rostr_user_clicked_unselect_all',
  ROSTR_USER_CLICKED_CLEAR_SCHEDULE = 'rostr_user_clicked_clear_schedule',
  ROSTR_USER_OPENED_VACAY_REQUEST_MANAGER = 'rostr_user_opened_vacay_request_manager',
  ROSTR_USER_SUBMITTED_VACAY_REQUEST = 'rostr_rp_submitted_vacay_request',
  ROSTR_USER_CLICKED_LOCK_APPROVE_ASSIGNED_VACAY = 'rostr_user_clicked_lock_approve_assigned_vacay',
  ROSTR_USER_CLICKED_LOCK_APPROVE_ASSIGNED_AGENDA = 'rostr_user_clicked_lock_approve_assigned_agenda',
  ROSTR_USER_USED_SEARCH_REPLACE = 'rostr_user_used_search_replace',
  ROSTR_USER_OPENED_REQUIRED_SHIFTS_REPORT = 'rostr_user_opened_required_shifts_report',
  ROSTR_USER_USED_UNDO_REDO_FEATURE = 'rostr_user_used_undo_redo_feature',
  ROSTR_USER_CLICKED_REVALIDATION = 'rostr_user_clicked_revalidation',
  ROSTR_USER_OPENED_VALIDATIONS_WINDOW = 'rostr_user_opened_validations_window',
  ROSTR_USER_APPLIED_VALIDATIONS_FILTER = 'rostr_user_applied_validations_filter',
  ROSTR_USER_REPORTED_SOLVER_ISSUE = 'rostr_user_reported_solver_issue',
  ROSTR_USER_STARTED_AVAI_SOLVER = 'rostr_user_started_avai_solver',
  ROSTR_USER_STOPPED_AVAI_SOLVER = 'rostr_user_stopped_avai_solver',
  ROSTR_USER_VIEWED_EMPLOYEE_INFO = 'rostr_user_viewed_employee_info',
  ROSTR_USER_CLICKED_EMPLOYEE_ORDER_MODE = 'rostr_user_clicked_employee_order_mode',
  ROSTR_USER_CHANGED_EMPLOYEE_ORDER = 'rostr_user_clicked_employee_order',
  ROSTR_USER_APPLED_EMPLOYEE_ORDER_MANUAL = 'rostr_user_saved_employee_order_manual',
  ROSTR_USER_CLICKED_EMPLOYEE_COLLAPSE_ALL = 'rostr_user_clicked_employee_collapse_all',
  ROSTR_USER_CLICKED_EMPLOYEE_EXPAND_ALL = 'rostr_user_clicked_employee_expand_all',
  ROSTR_USER_APPLIED_EMPLOYEE_FILTER = 'rostr_user_applied_employee_filter',
  ROSTR_USER_TRIGGERED_EASTEREGG = 'rostr_user_triggered_easteregg'
}
